import axios from "axios";

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        create({ commit }, photoForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/supply-chains/raw-item-photos", photoForm, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({ commit }, photoForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `/supply-chains/raw-item-photos/${photoForm.get("id")}`,
                        photoForm,
                        {
                            headers: { "Content-Type": "multipart/form-data" },
                        }
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({ commit }, { rawItemPhotoId, rawItemId }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(
                        `/supply-chains/raw-item-photos/${rawItemPhotoId}`,
                        {
                            params: {
                                raw_item_id: rawItemId,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore({ commit }, { rawItemPhotoId, rawItemId }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/supply-chains/raw-item-photos/${rawItemPhotoId}/restore`,
                        {
                            raw_item_id: rawItemId,
                        }
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
